import homeImage from '../images/home.jpg';
import Vision from '../components/Vision';
import AboutUs from "../components/HomeAboutUs";
import ChooseUs from "../components/ChooseUs";
import Applications from "../components/Applications";
import Clients from '../components/Clients';
import Projects from '../components/Projects';
import Testimonials from '../components/Testimonials';
import Certificates from '../components/Certificates';

function Home() {
  return (
    <>
      <div className='home-image'>
        <img src={homeImage} alt="Home background" />
      </div>
      <div className="home-content">
        <Vision />
        <AboutUs />
        <ChooseUs />
        <Applications />
        <Clients />
        <Projects />
        <Testimonials />
        <Certificates />
      </div>
    </>
  );
}

export default Home;